import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid2";

export default function SettingsPage() {
    return (
        <Grid container spacing={1} justifyContent="center">
            <Grid size={{xs: 12, md: 8, lg: 6 }}>
                <Typography component="h1" variant="h5">
                    Пользовательские настройки
                </Typography>
                {/*<UserAvatarManager />*/}
                {/*<UserPersonalDataManager />*/}
                {/*<BackupEmailUserManager />*/}
                {/*<NewPasswordForm />*/}
            </Grid>
        </Grid>
    );
}
